import {CourseContainer, Cross, Attending, Button, Edit, Close} from "./Course.styled";
import { useI18n } from '@i18n/useI18n';
import moment from "moment";
import {useEffect, useState} from "react";
import db from "@utils/db";
import {useStore} from "@store/appStore";
import RainbowLoader from "@components/Loaders/RainbowLoader";
import Cross_Icon from "@assets/svg/match/missing.svg";
import { BoxTop, Popup, PopupBox } from "@components/Redeem/Redeembackup.styled";

interface IProps{
    data?:any;
    even?:boolean
    edit?: boolean
    headers?: boolean
    index?: number
    editFunction?: (i) => void
    clearFunction?: () => void
    getLog?: () => void
}

const Course = (props:IProps) =>{
    const i18n = useI18n();
    const [startdate, setStartDate] = useState("");
    const [enddate, setEndDate] = useState("");
    const {client} = useStore()
    const [showPopup, setShowPopup] = useState(false)
    const [showWarningPopup, setShowWarningPopup] = useState(false)

    useEffect(() => {
        if (props.data)
        {
            if (props.data.startdate)setStartDate(moment(props.data.startdate).format("YYYY-MM-DD"))
            else if(props.data.startdate === null)setStartDate("")
            if (props.data.enddate)setEndDate(moment(props.data.enddate).format("YYYY-MM-DD"))
            else if(props.data.enddate === null)setEndDate("")
        }

    }, [props.data])

    useEffect(() => {
        if (props.edit === false)clearDates(false)
    }, [props.edit])


    const setStart = (e) => {        
        let d = moment(e.target.value)
        if (d.isValid())
        {
            setStartDate(d.format('YYYY-MM-DD'))
        }
        else
        {
            e.target.blur()
            e.target.focus()
            setStartDate(null)
        }
    }

    const setEnd = (e) => {
        let d = moment(e.target.value)
        if (d.isValid())
        {
            setEndDate(d.format('YYYY-MM-DD'))
        }
        else
        {
            e.target.blur()
            e.target.focus()
            setEndDate(null)
        }
    }

    const checkDate = (type) => {
        if (type === 1)
        {
            let d = moment(startdate)
            let minDate = moment().add(-2, 'year').startOf('year')
            if (d.isBefore(minDate))setStartDate("")
        }
        else
        {
            let d = moment(enddate)
            let maxDate = moment().add(2, 'year').endOf('year')
            if (d.isAfter(maxDate))setEndDate("")
        }
    }

    const updateDates = async () => {
        let dates = {startdate: startdate !== ""?startdate:null, enddate: enddate !== ""?enddate:null}
        let minDate = moment().add(-5,'years').startOf('date')
        let maxDate = moment().add(5,'years').endOf('date')
        let startDate = moment(dates.startdate)
        let endDate = moment(dates.enddate)

        let showPopup = false
        let showWarningPopup = false

        if (dates.startdate !== null && startDate.isBefore(minDate))showPopup = true
        if (dates.enddate !== null && endDate.isAfter(maxDate))showPopup = true
        if (dates.startdate !== null && dates.enddate !== null && endDate.isBefore(startDate))showWarningPopup = true
        if (dates.startdate !== null && dates.enddate !== null && startDate.isAfter(endDate))showWarningPopup = true

        if (!showPopup && !showWarningPopup)
        {
            await db.UpdateStudentRoster(props.data.student_sis_id, props.data.sis_id, client.UserName, dates)
            props.clearFunction()
            props.getLog()
        }
        else{
            if (showWarningPopup)setShowWarningPopup(true)
            else if(showPopup)setShowPopup(true)
        }
    }

    const handleBackspace = (e, type) => {
        if (e.key === "Backspace") {
            if (type === 1)
            {
                setStartDate("")
            }
            else if(type === 2)
            {
                setEndDate("")
            }
        }
    }

    const close = () => {
        clearDates(false)
        props.clearFunction()
    }

    const closePopup = () => {
        setShowPopup(false)
        setShowWarningPopup(false)
    }

    const clearDates = (buttonClick) => {
        if (props.data.startdate)setStartDate(moment(props.data.startdate).format("YYYY-MM-DD"))
        else setStartDate("")
        if (props.data.enddate)setEndDate(moment(props.data.enddate).format("YYYY-MM-DD"))
        else setEndDate("")
        if (buttonClick)props.clearFunction()
    }

    const updateDatesConfirm = async () => {
        let dates = {startdate: startdate !== ""?startdate:null, enddate: enddate !== ""?enddate:null}
        await db.UpdateStudentRoster(props.data.student_sis_id, props.data.sis_id, client.UserName, dates)
        props.clearFunction()
        setShowPopup(false)
        props.getLog()
    }

    return (
        <>
            {showPopup?<Popup show={showPopup}>
                <PopupBox>
                    <BoxTop>
                        <span>{i18n.t('confirm')}</span>
                        <button onClick={closePopup}>
                            <Cross_Icon />
                        </button>
                    </BoxTop>
                    <span></span>
                    <p>{i18n.t("date-warning")}</p>
                    <div>
                        <button onClick={closePopup}>{i18n.t("note-cancel")}</button>
                        <button onClick={updateDatesConfirm}>{i18n.t("ok")}</button>
                    </div>
                </PopupBox>
            </Popup>:<></>}
            {showWarningPopup?<Popup show={showWarningPopup}>
                <PopupBox>
                    <BoxTop>
                        <span>{i18n.t('oops')}</span>
                        <button onClick={closePopup}>
                            <Cross_Icon />
                        </button>
                    </BoxTop>
                    <span></span>
                    <p>{i18n.t("invalid-dates")}</p>
                    <div>
                        <button onClick={closePopup}>{i18n.t("ok")}</button>
                    </div>
                </PopupBox>
            </Popup>:<></>}
        <CourseContainer headers={props.headers} even={props.even}>
            {props.headers?<>
                <span>{i18n.t("course-displayname")}</span>
                <span>{i18n.t("course-startdate")}</span>
                <span>{i18n.t("course-enddate")}</span>
                <span></span>
                <span></span>
            </>:<>
                <span>{props.data.displayname}</span>
            {props.edit?<><input onKeyDown={(e) => handleBackspace(e,1)} min={"2022-01-01"} value={startdate || ''} type={"date"} onChange={(e) => setStart(e) }/>
                <input min={"2022-01-01"} onKeyDown={(e) => handleBackspace(e,2)} value={enddate || ''} type={"date"} onChange={(e) => setEnd(e) }/>
                <Button onClick={() => clearDates(true)}><Cross /></Button>
                <Button onClick={updateDates}><Attending /></Button>
            </>:<><span>{startdate === ""?"-":moment(startdate).format("DD-MM-YYYY")}</span><span>{enddate === ""?"-":moment(enddate).format("DD-MM-YYYY")}</span><span></span><Button onClick={() => props.editFunction(props.index)}><Edit /></Button></>}

            </>}
        </CourseContainer>
            </>
    )
}

export default Course;
